import React from 'react';

import NodeGraph from './NodeGraph';

function PrimeClockGraph() {
  // To avoid a rehydration error, where the time on the server
  // is different from the time on the client, we'll make this
  // component client-side-only
  const [hasMounted, setHasMounted] = React.useState(false);

  // Rules of Hooks is upset because of the unconditional state change, but I know it's fine.
  // eslint-disable-next-line
  React.useEffect(() => {
    setHasMounted(true);
  });

  if (!hasMounted) {
    return null;
  }

  return (
    <NodeGraph
      initialState={{
        time: new Date(),
        selectedNum: 10,
      }}
      rows={[
        [
          {
            label: 'App',
          },
        ],
        [
          {
            label: 'Clock',
            parentId: 'app',
            ownsState: 'time',
            dependsOnState: 'time',
            isPureSecretly: true,
          },
          {
            label: 'PrimeCalculator',
            parentId: 'app',
            ownsState: 'selectedNum',
            dependsOnState: 'selectedNum',
            isPureSecretly: true,
          },
        ],
      ]}
    />
  );
}

export default PrimeClockGraph;
